import { render, staticRenderFns } from "./StatusHistoryDialog.vue?vue&type=template&id=2d1bb885&scoped=true&"
import script from "./StatusHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./StatusHistoryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1bb885",
  null
  
)

export default component.exports